import { Component, OnDestroy, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { config } from '../../../config/config';
import { CgpSnackbarService } from '../cgp-snackbar/cgp-snackbar.service';

import * as moment from 'moment';

@Component({
    selector: 'cgp-notification-menu',
    templateUrl: './cgp-notification-menu.template.html',
    styleUrls: ['./cgp-notification-menu.style.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [CgpSnackbarService]
})

export class CgpNotificationMenuComponent implements OnDestroy, AfterViewInit {
    public notifications = [];
    private readonly notificationTimer = config.notifications.refreshTimer;
    private hasRanInitialFetch = false;
    private notificationsRefreshTimer = null;
    private readonly notificationsApiSubscription = null;

    private readonly messages = {
        newNotifications: ' New Notification(s)',
        notificationDeleted: 'Notification deleted',
        dismiss: 'Dismiss'
    };

    constructor(private readonly cgpSnackbarService: CgpSnackbarService) { }

    ngAfterViewInit() {
        this.getNotifications();
        this.startNotificationsRefresh();
    }

    ngOnDestroy() {
        this.memoryCleanup();
    }

    memoryCleanup() {
        this.notificationsApiSubscription.unsubscribe();
        clearInterval(this.notificationsRefreshTimer);
    }

    startNotificationsRefresh() {
        const timerInterval = this.notificationTimer;

        this.notificationsRefreshTimer = setInterval(() => {
            this.getNotifications();
        }, timerInterval * 60000);
    }

    getNotifications() {
        // Application specific: get notifications service call
        //
        this.notifications = [];
        this.hasRanInitialFetch = true;
    }

    getNumberOfNewNotifications(oldNotifications, newNotifications) {
        let numberOfNewNotifications = 0;

        if (oldNotifications && newNotifications) {
            const oldNotificationIds = oldNotifications.map(notification => notification.id);
            const newNotifictationIds = newNotifications.map(notification => notification.id);

            numberOfNewNotifications = newNotifictationIds.filter(notificationId => {
                return oldNotificationIds.indexOf(notificationId) < 0;
            }).length;
        }

        return numberOfNewNotifications;
    }

    getUnreadNotificationCount() {
        return this.notifications.filter(notification => notification.hasBeenRead === false).length;
    }

    getUnreadNotificationDisplayString() {
        const unreadNotificationCount = this.getUnreadNotificationCount();
        return (unreadNotificationCount > 99) ? '99+' : unreadNotificationCount.toString();
    }

    getFormattedDate(date: Date) {
        return moment.utc(date).format('DD-MMM-YYYY').toUpperCase();
    }

    updateNotification(notification, state) {
        switch (state) {
            case 'delete':
                this.deleteNotification(notification);
                break;
            case 'markAsRead':
                this.markNotificationAsRead(notification);
                break;
            default:
                console.error('Failed to update notification - Unknown notification state', notification, state);
                break;
        }
    }

    deleteNotification(notification) {
        // Application specific: delete notification service call
        //
    }

    markNotificationAsRead(notification) {
        // Application specific: update notification service call
        //
    }

    notificationClickHandler(notification) {
        // Application specific: notification click handling
        //
    }

    removeNotification(notification) {
        this.notifications = this.notifications.filter(e => e.id !== notification.id);
    }

    styleNotificationBell() {
        const notificationCount = (this.notifications) ? this.notifications.length : 0;
        return (notificationCount > 0) ? 'notification-bell-read' : 'notification-bell-none';
    }

    styleNotificationMessage(notification) {
        // Application specific: determine if notification is styled as link or a message
        // return 'link' || 'message'
        return 'message';
    }

    styleNotificationContainer(notification) {
        return (notification.hasBeenRead) ? 'notification-read-container' : 'notification-unread-container';
    }

    styleNotificationTitle(notification) {
        return (notification.hasBeenRead) ? 'notification-read-title' : 'notification-unread-title';
    }
}